import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { gallery } from "../mock";

const Gallery = () => {
  const [index, setIndex] = useState(0);
  const [perView, setPerView] = useState(4);
  const [lightbox, setLightbox] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    const calc = () => setPerView(window.innerWidth < 640 ? 1 : window.innerWidth < 1024 ? 2 : 4);
    calc();
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);
  }, []);

  const maxIndex = Math.max(0, gallery.length - perView);
  useEffect(() => {
    timer.current = setInterval(() => setIndex((i) => (i >= maxIndex ? 0 : i + 1)), 4000);
    return () => clearInterval(timer.current);
  }, [maxIndex]);

  const prev = () => setIndex((i) => (i <= 0 ? maxIndex : i - 1));
  const next = () => setIndex((i) => (i >= maxIndex ? 0 : i + 1));

  return (
    <section className="py-6 bg-white" data-testid="gallery-carousel">
      <div className="max-w-[1140px] mx-auto px-4">
        <div className="relative">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-out"
              style={{ transform: `translateX(-${index * (100 / perView)}%)` }}
            >
              {gallery.map((g, i) => (
                <div key={i} className="flex-shrink-0 px-[10px]" style={{ width: `${100 / perView}%` }}>
                  <button
                    onClick={() => setLightbox(g)}
                    className="block w-full aspect-[3/4] overflow-hidden gallery-img"
                  >
                    <img src={g.src} alt={g.alt} loading="lazy" className="w-full h-full object-cover" />
                  </button>
                </div>
              ))}
            </div>
          </div>

          <button onClick={prev} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 text-white/90 hover:text-fire transition-colors flex items-center justify-center z-10 drop-shadow" aria-label="Previous">
            <ChevronLeft size={30} />
          </button>
          <button onClick={next} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 text-white/90 hover:text-fire transition-colors flex items-center justify-center z-10 drop-shadow" aria-label="Next">
            <ChevronRight size={30} />
          </button>
        </div>

        <div className="flex justify-center gap-2 mt-5">
          {Array.from({ length: maxIndex + 1 }).map((_, i) => (
            <button key={i} onClick={() => setIndex(i)} className={`h-2.5 rounded-full transition-all ${i === index ? "w-2.5 bg-fire" : "w-2.5 bg-gray-300 hover:bg-gray-400"}`} aria-label={`Go to slide ${i + 1}`} />
          ))}
        </div>
      </div>

      {lightbox && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" onClick={() => setLightbox(null)}>
          <div className="absolute inset-0 bg-black/85" />
          <button className="absolute top-6 right-6 text-white/80 hover:text-white z-10" aria-label="Close"><X size={30} /></button>
          <img src={lightbox.src} alt={lightbox.alt} className="relative max-h-[85vh] max-w-[90vw] rounded-lg shadow-2xl" />
        </div>
      )}
    </section>
  );
};

export default Gallery;
